import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { AnalyticsIcon } from 'src/v3/core/icons'

export default function QuizAnalyticsEmptyState({
  title,
  description,
}: {
  title: string
  description: string
}) {
  return (
    <Paper
      className="flex flex-col items-center justify-center gap-2 text-center"
      sx={{ p: 3, py: 8 }}
    >
      <AnalyticsIcon
        aria-hidden="true"
        sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }}
      />
      <Typography variant="h6" component="h2">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Paper>
  )
}
